const inelegibleRoutes = [
  {
    path: '/ineligible-list',
    name: 'ineligible-list.list',
    component: () => import('@/views/ineligible-list/IneligibleList.vue'),
  },

]
export default inelegibleRoutes
